import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/guanhuai',
    baseurl2:'/api/swyl/v1',
    //用户交互头部
    headline(query){
        return http({
            url: this.baseurl+'/userCarePlan/getToday',
            method: 'post',
            params: query
        });
    },
    //用户交互下方实际跑动
    allexec(query){
        return http({
            url: this.baseurl+'/userCareExecution/listByModelPage',
            method: 'post',
            params: query
        });
    },
    //用户交互我的日程-未完成计划
    allplan(query){
        return http({
            url: this.baseurl+'/userCarePlan/getMonth',
            method: 'post',
            params: query
        });
    },
    //实际跑动 左面列表
    selectPage(query){
        return http({
            url: this.baseurl+'/userCarePlan/selectPage',
            method: 'post',
            params: query
        });
    },
    //实际跑动 右面echart
    planChart(query){
        return http({
            url: this.baseurl+'/userCarePlan/chartPer',
            method: 'post',
            params: query
        });
    },
    //实际跑动 右边详情
    planDetail(query){
        return http({
            url: this.baseurl+'/userCarePlan/getById',
            method: 'post',
            params: query
        });
    },
    //实际跑动 右边详情
    planDetail2(query){
        return http({
            url: this.baseurl+'/userCarePlan/getByModel',
            method: 'post',
            params: query
        });
    },
    //日清列表
    page(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/selectPage',
            method: 'post',
            params: query
        });
    },
    gradeRanking(query){
        return http({
            url: this.baseurl+'/userCareRanking/gradeRanking',
            method: 'post',
            params: query
        });
    },
    //排名
    ranking(query){
        return http({
            url: this.baseurl+'/userCareRanking/selectPage',
            method: 'post',
            params: query
        });
    },
    //用户交互下面实际跑动导出Excel
    export(query){
        return http({
            url: this.baseurl+'/userCarePlan/downloadExcel',
            method: 'post',
            params: query
        });
    },
    //获取当天所有的跑动记录
    queryExecution(query){
        return http({
            url: this.baseurl+'/userCareExecution/listTodays',
            method: 'post',
            params: query
        });
    },
    //提交日清提报
    submitSummary(query){
        return http({
            url: this.baseurl+'/userCarePlan/insertSummary',
            method: 'post',
            data: query
        });
    },
    //提交日清提报
    checkSummary(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/checkSummary',
            method: 'post',
            data: query
        });
    },
    //判断今天日清提交了没有
    riqiFlag(query){
        return http({
            url: this.baseurl+'/userCarePlan/riqiFlag',
            method: 'post',
            params: query
        });
    },
    //查询这个用户有没有暂存状态的周计划和周计划时间范围
    weekPlanFirst(query){
        return http({
            url: this.baseurl+'/userCarePlan/weekPlanList',
            method: 'post',
            data: query
        });
    },
    //查询这个用户有没有暂存状态的周计划和周计划时间范围
    weekPlanDetailFirst(query){
        return http({
            url: this.baseurl+'/userCarePlan/weekPlanListDetail',
            method: 'post',
            data: query
        });
    },
    //查询用户信息
    customerOption(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showCustDetail',
            method: 'post',
            data: query
        });
    },
    //查询客户经销商信息
    agentOption(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showAgentDetail',
            method: 'post',
            data: query
        });
    },
    //查询用户信息协同问题用
    customerOptionXieTong(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showCustDetailXieTong',
            method: 'post',
            data: query
        });
    },
    //查询客户经销商信息协同问题用
    agentOptionXieTong(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showAgentDetailXieTong',
            method: 'post',
            data: query
        });
    },
    //查询客户经销商信息,项目用
    agentOptionPm(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showAgentDetailPm',
            method: 'post',
            data: query
        });
    },
    //查询客户经销商信息
    agentOptionSh(query){
        return http({
            url: this.baseurl2+'/yonghu/bscCustomer/showAgentSh',
            method: 'post',
            data: query
        });
    },
    //保存交互周计划
    savePlan(query){
        return http({
            url: this.baseurl+'/userCarePlan/insertBetch',
            method: 'post',
            data: query
        });
    },
    //保存交互周计划
    updateById(query){
        return http({
            url: this.baseurl+'/userCarePlan/updateById',
            method: 'post',
            params: query
        });
    },
    //审核交互周计划
    checkPlanWeek(query){
        return http({
            url: this.baseurl+'/userCarePlan/checkPlanWeek',
            method: 'post',
            data: query
        });
    },
    //审核交互过期提报
    checkPlanOver(query){
        return http({
            url: this.baseurl+'/userCarePlan/checkSingleplan',
            method: 'post',
            data: query
        });
    },
    //审核交互周计划
    weekPlanStatus(){
        return http({
            url: this.baseurl+'/userCarePlan/weekPlanStatus',
            method: 'post',
        });
    },
    //判断今天日清提交了没有
    publishCheck(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/publishCheck',
            method: 'post',
            params: query
        });
    },
    //发布排行展示
    publishPage(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/publishPage',
            method: 'post',
            params: query
        });
    },
    //发布排行展示
    rankingP(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/rankingP',
            method: 'post',
            params: query
        });
    },
    //发布排行展示
    publicPh(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/publicPh',
            method: 'post',
            params: query
        });
    },
    //请假信息
    publicQj(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/publicQj',
            method: 'post',
            data: query
        });
    },
    //查询是否已经发布排行
    publishedCheck(query){
        return http({
            url: this.baseurl+'/userCareRanking/publishedCheck',
            method: 'post',
            params: query
        });
    },
    //展示图片
    imgDown(id){
        return http({
            url: '/api/file/fileopt/down?id='+id,
            responseType: "arraybuffer"
        });
    },
    whlPage(query){
        return http({
            url: this.baseurl+'/userCarePlan/whlPage',
            method: 'post',
            params: query
        });
    },
    tzGrade(query){
        return http({
            url: this.baseurl+'/userCareDailySummary/tzGrade',
            method: 'post',
            data: query
        });
    },
    saveJingPin(query){
        return http({
            url: this.baseurl+'/userCarePlan/saveJingPin',
            method: 'post',
            data: query
        });
    },
    deleteExe(query){
        return http({
            url: this.baseurl+'/userCareExecution/deleteExe',
            method: 'post',
            data: query
        });
    },
    planStatusPage(v){
        return http({
            url:'/api/swyl/v1/guanhuai/userCarePlan/planStatusPage',
            method: 'post',
            params: v
        });
    },
    tixing(v){
        return http.post('/api/swyl/v1/guanhuai/userCarePlan/tixing?usercode='+v);
    }
}
